// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import VueCordova from 'vue-cordova'
import VueHead from 'vue-head'
import VeeValidate from 'vee-validate'
import Vue2Filters from 'vue2-filters'
import { sync } from 'vuex-router-sync'
import colors from 'vuetify/lib/util/colors'
import 'font-awesome/css/font-awesome.min.css'
// import '@fortawesome/fontawesome-free/css/all.css'

import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'
import attributesEn from './locales/attributes/en.js'
import attributesMy from './locales/attributes/my.js'
import attributesCn from './locales/attributes/cn.js'
import messagesEn from './locales/messages/en.js'
import messagesMy from './locales/messages/my.js'
import messagesCn from './locales/messages/cn.js'

import 'moment/locale/ms.js'
import moment from 'moment-timezone'
import fileSize from 'file-size'
import VueQrcode from '@chenfengyuan/vue-qrcode'

const Plugins = {
  install (Vue) {
    Vue.$moment = moment
    Vue.$fileSize = fileSize
  }
}

Vue.prototype.$moment = moment
Vue.component(VueQrcode.name, VueQrcode)

Vue.filter('status', function (value) {
  switch (value) {
    case 'successful': return i18n.t('successful')
    case 'failed': return i18n.t('failed')
    case 'in_progress': return i18n.t('in_progress')
    default: return value
  }
})
Vue.filter('machine', function (value) {
  switch (true) {
    case value === 'A10': return i18n.t('guest')
    case value === 'A11': return i18n.t('registered_user')
    case value !== 'A11' && value !== 'A10': return i18n.t('remote_counter')
    default: return value
  }
})

Vue.filter('ringgit', function (value) {
  const decimals = 2
  const decimalPoint = '.'
  const thousandsSeparator = ','

  const sign = value < 0 ? '-' : ''
  value = Math.abs(+value || 0) / 100

  const intPart = parseInt(value.toFixed(decimals), 10) + ''
  const j = intPart.length > 3 ? intPart.length % 3 : 0

  return (
    sign +
    (j ? intPart.substr(0, j) + thousandsSeparator : '') +
    intPart.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousandsSeparator) +
    (decimals
      ? decimalPoint +
        Math.abs(value - intPart)
          .toFixed(decimals)
          .slice(2)
      : '')
  )
})

Vue.filter('paymentType', function (value) {
  switch (value) {
    case 'assessment': return i18n.t('assessment')
    case 'market': return i18n.t('market')
    case 'council': return i18n.t('council')
    case 'trading': return i18n.t('trading')
    case 'compound': return i18n.t('compound')
    case 'ppr': return i18n.t('ppr')
    default: return value
  }
})

Vue.filter('payment_id', function (value) {
  switch (value) {
    case '2': return 'Kad Kredit'
    case '6': return 'Maybank2U'
    case '8': return 'Alliance Bank'
    case '10': return 'Ambank'
    case '14': return 'RHB Bank'
    case '15': return 'Hong Leong Bank'
    case '20': return 'CIMB Clicks'
    case '22': return 'Web Cash'
    case '31': return 'Public Bank'
    case '48': return 'PayPal'
    case '100': return 'Celcom AirCash'
    case '102': return 'Bank Rakyat'
    case '103': return 'Affin Bank'
    case '124': return 'BSN'
    case '134': return 'Bank Islam'
    case '152': return 'UOB'
    case '166': return 'Bank Muamalat'
    case '167': return 'OCBC'
    case '168': return 'Standard Chartered'
    case '198': return 'HSBC Bank'
    case '199': return 'KFH'
    case '16': return 'FPX'
    default: return value
  }
})

Vue.filter('date', function (value) {
  return Vue.$moment(value).format('DD/MM/YYYY')
})

Vue.filter('dateTime', function (value) {
  return Vue.$moment(value).format('DD/MM/YYYY HH:MM A')
})

Vue.filter('fileSize', function (value) {
  return Vue.$fileSize(value).human('si')
})

Vue.config.productionTip = false
Vue.use(Plugins)
Vue.use(VueCordova)
Vue.use(VueHead)
Vue.use(VeeValidate, {
  dictionary: {
    en: { attributes: attributesEn, messages: messagesEn },
    my: { attributes: attributesMy, messages: messagesMy },
    cn: { attributes: attributesCn, messages: messagesCn }
  },
  locale: 'my'
})
Vue.use(Vue2Filters)

sync(store, router)

// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}

Vue.use(Vuetify)
const vuetify = new Vuetify({
  icons: {
    iconfont: 'fa4' // 'md' || 'mdi' || 'fa' || 'fa4'
  },
  theme: {
    themes: {
      light: {
        primary: colors.indigo.darken1,
        secondary: colors.teal.darken1,
        accent: colors.pink.darken1,
        error: colors.red.darken1,
        warning: colors.amber.darken1,
        info: colors.blue.darken1
      }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  vuetify,
  el: '#app',
  i18n,
  router,
  template: '<App/>',
  components: { App },
  head: {
    meta: [
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
      }
    ],
    script: [
      { type: 'text/javascript', src: 'pdfjs/pdf.js' },
      { type: 'text/javascript', src: 'pdfjs/pdf.worker.min.js' }
    ]
  },
  store
})
